import { ComponentInfo } from '@ipensii/shared/domain-shared';

export interface ComponentInfoState {
  componentInfo?: ComponentInfo;
  error?: Error;
}

export const initialComponentInfoState: ComponentInfoState = {};
